import { ConsumerShortNews, ConsumerShortNewsFull } from '@interfaces/consumer/shortNews';
import { PanelTableData } from '@interfaces/panel';
import { PatchConsumerShortNewsModel, PutConsumerShortNewsModel } from '@models/consumer/shortNews';
import { PanelTableDataModel } from '@models/panel';
import IService from '../iService';

export default class ConsumerShortNewsService extends IService {

    fetchConsumerShortNewsList = async (model: PanelTableDataModel) => {
        return await this.postApi<PanelTableData<ConsumerShortNews[]>>('/api/consumer/shortnews/', model);
    }

    async fetchConsumerShortNews(id: string) {
        return await this.getApi<ConsumerShortNewsFull>(`/api/consumer/shortnews/full/${id}/`);
    }

    async putConsumerShortNews(news: PutConsumerShortNewsModel) {
        return await this.putApi<string>('/api/consumer/shortnews/', news);
    }

    async patchConsumerShortNews(news: PatchConsumerShortNewsModel) {
        return await this.patchApi('/api/consumer/shortnews/', news);
    }

    deleteConsumerShortNews(id: string) {
        return this.deleteApi(`/api/consumer/shortnews/${id}/`);
    }
}